// eslint-disable-next-line import/no-cycle
import { APIS, clients } from '@/core/clients';

const client = clients[APIS.SELF_SERVICE.name];

const annotationsApi = {
  getBrandSafetyClassifiers() {
    return client.get('/annotations/annotations/corpus-configuration/brandsafety')
      .then((response) => response.data);
  },
  updateAnnotations(payload) {
    return client.post(`/annotations/annotations/annotation?advId=${payload.advId}&pubId=${payload.pubId}&label=${payload.label}&corpus=${payload.corpus}&author=${payload.author}`)
      .then((response) => response.data);
  },
};
export default annotationsApi;
